(() => {
  if (window.clikeaPurchaseOptionsBound) return;
  window.clikeaPurchaseOptionsBound = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cl-buy-quantity]');
    if (!button || button.disabled) return;
    const form = button.closest('.js-product');
    if (!form) return;
    const visible = element => element.getClientRects().length > 0;
    const wholesale = [...form.querySelectorAll('.clw-campaign')].find(visible);
    const quantity = [...form.querySelectorAll('.clpdp-quantity-picker')].find(visible);
    const target = wholesale || quantity;
    if (!target) return;
    target.open = true;
    target.scrollIntoView({block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    target.querySelector('summary')?.focus({preventScroll: true});
  });
})();
